import { render } from "./Deletes.vue?vue&type=template&id=675acec0"
import script from "./Deletes.vue?vue&type=script&lang=js"
export * from "./Deletes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__